module.exports = __webpack_public_path__ + "static/media/next.7af5a20b.png";